import React from "react";
import LoadingMessage from "../organisms/LoadingMessage";
const Loading = ({ title }) => (React.createElement(LoadingMessage, { title: title }));
export default Loading;
